var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4998 21.0001V17.0001H10.4998V21.0001H6.99985C6.73463 21.0001 6.48028 20.8947 6.29274 20.7072C6.10521 20.5197 5.99985 20.2653 5.99985 20.0001V14.0001H3.41385C3.2161 14.0001 3.0228 13.9414 2.85839 13.8315C2.69398 13.7216 2.56584 13.5654 2.49017 13.3827C2.4145 13.2 2.3947 12.999 2.43327 12.8051C2.47183 12.6111 2.56704 12.4329 2.70685 12.2931L11.2928 3.70709C11.4804 3.51962 11.7347 3.41431 11.9998 3.41431C12.265 3.41431 12.5193 3.51962 12.7068 3.70709L21.2928 12.2931C21.4327 12.4329 21.5279 12.6111 21.5664 12.8051C21.605 12.999 21.5852 13.2 21.5095 13.3827C21.4339 13.5654 21.3057 13.7216 21.1413 13.8315C20.9769 13.9414 20.7836 14.0001 20.5858 14.0001H17.9998V20.0001C17.9998 20.2653 17.8945 20.5197 17.707 20.7072C17.5194 20.8947 17.2651 21.0001 16.9998 21.0001H13.4998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.113998650fdd0672bb32e661dad130aa.svg";
export { ForwardRef as ReactComponent };